module.exports = __webpack_public_path__ + "static/lumerate-logo-1dcea7ec36eeeeadfe678ab1352c958e.jpeg";